module.exports = __webpack_public_path__ + "media/lesson/fonts/Frutiger/FrutigerLight-fb0c18e11263a9c48323f73b60122414.ttf";